import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/Home/index';
import AboutPage from './pages/Home/AboutPage';
import ServicesPage from './pages/Home/services';
import ServiceDetailPage from './pages/Home/ServiceDetail';
import PracticeHubPage from './pages/Home/PracticeHub';
import ContactPage from './pages/Home/contact';
 import EventsPage from './pages/Home/events'; 
 import InsightsPage from './pages/Home/insights';
import CareersPage from './pages/Home/careers';
import PrivacyPolicyPage from './pages/Home/PrivacyPolicy';
import NotFoundPage from './pages/Home/NotFound';
import AdminHomePage from './pages/Admin/adminHome';
import AdminLoginPage from './pages/Admin/adminLogin';
import AdminEventsPage from './pages/Admin/adminEvents';
import AdminJobsPage from './pages/Admin/adminJobs';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header/Header';
import Footer from './components/Header/Footer';
import AdminInsightsPage from './pages/Admin/adminInsights';
import RequireAdmin from './auth/RequireAdmin';
import Seo, { seoPropsFor } from './components/Seo/Seo';
import { PAGE_SEO } from './content/site';

function App() {
  return (
    <Router>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          {/* Services is three levels: the overview routes to a practice, the
              practice hub routes to a service, the service page is the leaf.
              There is no flat /services/:serviceSlug shape -- a service is
              addressable under its own practice and nowhere else, so the same
              content is never served from two URLs. */}
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:practiceSlug" element={<PracticeHubPage />} />
          <Route path="/services/:practiceSlug/:serviceSlug" element={<ServiceDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
           <Route path="/events" element={<EventsPage />} /> 
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

          {/* Auth Entry Point. The noindex <Seo> is mounted here rather than
              inside each admin page so that any admin route added later is
              covered by default. */}
          <Route path="/admin/login" element={<><Seo {...seoPropsFor(PAGE_SEO.admin)} /><AdminLoginPage /></>} />

          {/* Protected admin routes */}
          <Route path="/admin" element={<><Seo {...seoPropsFor(PAGE_SEO.admin)} /><RequireAdmin /></>}>
            <Route index element={<Navigate to="/admin/home" replace />} />
            <Route path="home" element={<AdminHomePage />} />
            <Route path = "insights" element={<AdminInsightsPage />} />
            <Route path = "jobs" element={<AdminJobsPage />} />
            <Route path = "events" element={<AdminEventsPage />} />
          </Route>

          {/* Catch all unauthorized */}
          <Route
            path="/unauthorized"
            element={<><Seo {...seoPropsFor(PAGE_SEO.unauthorized)} /><div>Unauthorized Access</div></>}
          />

          {/* Anything else. Must stay last -- it matches every path, so any
              route declared after it is unreachable. Without it an unknown URL
              rendered the header, an empty <main>, and the footer. */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
